import { useCallback } from 'react';
import { useIsOnlineContext } from '../../contexts/IsOnlineContext';
import { localDataService } from '../../services/localDataService';
import { updateTask } from '../../api/services/taskService';
import { TaskStatus } from '../../pages/inspector/timelineItem';

export const useUpdateTaskStatusToInProgress = () => {
  const { isOnline } = useIsOnlineContext();

  const updateTaskStatusToInProgress = useCallback(
    async (taskData: any): Promise<any | null> => {
      const currentStatus = taskData?.status;
      if (
        !taskData?.refId ||
        currentStatus === TaskStatus.IN_PROGRESS ||
        currentStatus === TaskStatus.COMPLETED
      ) {
        return null;
      }

      const body = {
        status: TaskStatus.IN_PROGRESS,
        updateTime: Date.now(),
      };

      try {
        if (isOnline) {
          try {
            await updateTask(taskData.refId, body);
            return { ...taskData, status: TaskStatus.IN_PROGRESS };
          } catch (err) {}
        } else {
          const updatedTask = await localDataService.update('task', taskData.refId, body);
          return updatedTask || { ...taskData, status: TaskStatus.IN_PROGRESS };
        }
      } catch (error) {
        return null;
      }
    },
    [isOnline]
  );

  return { updateTaskStatusToInProgress };
};
